import { Injectable } from "@angular/core";
import { HttpBackend } from "@angular/common/http";
import { CfgService } from "../../../../cfg/cfg.service";
import { ServerAddressesCfgService } from "src/app/util/serverAddressesCfg.service";

export class AbsencesCfg {
  public summaryEndpointPattern: string;
  public detailEndpointPattern: string;
}

export class AbsencesDirectKpiCfg {
  public absences: AbsencesCfg;
}

@Injectable()
export class AbsencesDirectKpiCfgService extends CfgService<AbsencesDirectKpiCfg> {
  json: any = {
    absences: {
      summaryEndpointPattern: "%{DashboardDirectApiUrl}/absences/{0}?date={1}",
      detailEndpointPattern: "%{DashboardDirectApiUrl}/absences/{0}/detail?date={1}"
    }
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/kpi/absencesDirectKpi.cfg.json`;
  }

  /**
  * Carga las url en el json
  */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
